import useChangeBalance from 'components/Dashboard/Orgs/Wizard/OrgBilling/ChangeBalanceForm/useChangeBalance';

import React from 'react';
import { Button, Form, InputNumber, Space } from 'antd';

interface FormValues {
  amount: number;
}

interface Props {
  orgId: string;
  onCancel: () => void;
  replenish: boolean;
}

const ChangeBalanceForm: React.FC<Props> = ({ orgId, onCancel, replenish }) => {
  const [ form ] = Form.useForm<FormValues>();
  const { isLoading, changeBalance } = useChangeBalance(replenish, onCancel);

  const onFinish = (values: FormValues) => changeBalance(orgId, values.amount);

  return (
    <Form
      form={form}
      name="replenish"
      style={{ width: 360 }}
      layout="vertical"
      onFinish={onFinish}
      disabled={isLoading}
    >
      <Form.Item name="amount" label="Amount of credits" rules={[ { required: true, message: 'Field is mandatory' } ]}>
        <InputNumber placeholder="Enter amount of credits" style={{ width: '100%' }} min={1} />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            {replenish ? 'Replenish' : 'Write off'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ChangeBalanceForm;
